<app-advanced-tooltip>
  <tooltip-body>
    @if (snoozed()) {
      <mat-icon [class.small-icon]="smallIcon">snooze</mat-icon>
    } @else if (critical()) {
      <mat-icon [class.small-icon]="smallIcon" color="warn">priority_high</mat-icon>
    } @else if (warning()) {
      <mat-icon [class.small-icon]="smallIcon" class="yellow">question_mark</mat-icon>
    }
  </tooltip-body>
  <tooltip-popout>
    @for (t of tooltip(); track t) {
      <p class="alert-icon-tooltip-line">{{ t }}</p>
    }
  </tooltip-popout>
</app-advanced-tooltip>
